import { useMutation, useQueryClient } from 'react-query';
import { saveUserPreference, UserPreferenceKeys, UserPreferences } from './UserPreferencesApi';
import { UserPreferencesQueryKey, useUserPreferencesQueryKey } from './useUserPreferencesQuery';

type SaveUserPreference = {
    key: UserPreferenceKeys;
    value: string;
};

type SaveContext = {
    savingUserQueryKey: UserPreferencesQueryKey;
};

export function useSaveUserPreferenceMutation() {
    const queryClient = useQueryClient();
    const currentUserQueryKey = useUserPreferencesQueryKey();

    return useMutation<void, unknown, SaveUserPreference, SaveContext>(
        ({ key, value }: SaveUserPreference) => saveUserPreference(key, value),
        {
            // Taken when saving starts, so a user change during the request can't redirect the update.
            onMutate: () => ({ savingUserQueryKey: currentUserQueryKey }),
            onSuccess: (_result: void, { key, value }: SaveUserPreference, context: SaveContext) => {
                queryClient.setQueryData<UserPreferences>(
                    context.savingUserQueryKey,
                    (current: UserPreferences) => ({ ...current, [key]: value })
                );
            }
        }
    );
}
